import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  profile: {
    name: "Musa Yusuf Magoban",
    title: "Cybersecurity Professional",
    subtitle: "Security Operations Analyst | Threat Detection Expert",
    description: "Passionate cybersecurity professional with expertise in SOC operations, malware analysis, and security automation. Dedicated to protecting organizations through proactive threat detection and incident response.",
    location: "Nigeria",
    email: "contact@musayusuf.com",
    phone: "+234 XXX XXX XXXX",
    linkedin: "https://linkedin.com/in/musayusuf",
    github: "https://github.com/Magoban",
    website: "https://musayusuf.com"
  },
  highlights: [
    {
      id: '1',
      title: "6+ Projects",
      description: "Hands-on cybersecurity projects"
    },
    {
      id: '2',
      title: "SOC Lab",
      description: "Built comprehensive security operations center"
    },
    {
      id: '3',
      title: "AI Integration",
      description: "Automated threat detection using AI"
    },
    {
      id: '4',
      title: "SOAR Workflows",
      description: "Developed automated incident response"
    }
  ]
};

const aboutSlice = createSlice({
  name: 'about',
  initialState,
  reducers: {
    updateProfile: (state, action) => {
      state.profile = { ...state.profile, ...action.payload };
    },
    addHighlight: (state, action) => {
      const newHighlight = {
        ...action.payload,
        id: Date.now().toString()
      };
      state.highlights.push(newHighlight);
    },
    updateHighlight: (state, action) => {
      const { id, ...updates } = action.payload;
      const highlightIndex = state.highlights.findIndex(highlight => highlight.id === id);
      if (highlightIndex !== -1) {
        state.highlights[highlightIndex] = { ...state.highlights[highlightIndex], ...updates };
      }
    },
    deleteHighlight: (state, action) => {
      state.highlights = state.highlights.filter(highlight => highlight.id !== action.payload);
    },
    setHighlights: (state, action) => {
      state.highlights = action.payload;
    }
  }
});

export const { updateProfile, addHighlight, updateHighlight, deleteHighlight, setHighlights } = aboutSlice.actions;
export default aboutSlice.reducer; 